import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "d-flex align-items-center text-dark order-2 order-md-1" }
const _hoisted_3 = { class: "text-muted fw-bold me-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.sushieden.co.nz/",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}, "Sushi Eden", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.year) + "©", 1),
        _hoisted_4,
        _createElementVNode("span", {
          class: _normalizeClass(["badge fw-bold fs-9 px-2 ms-2", `badge-light-${_ctx.versionColor}`])
        }, " v" + _toDisplayString(_ctx.version), 3)
      ])
    ], 2)
  ]))
}